import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

const Layout = () => {
    const location = useLocation();

    const getTitle = () => {
        switch (location.pathname) {
            case '/accounts': return 'Quản lý tài khoản';
            case '/jobs': return 'Quản lý công việc';
            case '/training': return 'Gương sáng vươn lên';
            case '/news': return 'Chính sách hỗ trợ';
            case '/banner': return 'Quản lý banner';
            default: return 'Quản lý tài khoản';
        }
    };

    return (
        <div className="app-container">
            <Sidebar />
            <div className="main-content">
                <Header title={getTitle()} />
                <div className="content-area">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default Layout;
